import type { FaireProductEntity } from "../../entity_types/product";

export const p_4fw664xbhh: FaireProductEntity = {
  token: "p_4fw664xbhh",
  type: "product",
  name: "Cotton Tie Dye Stripe Patch Boho Hippie Pants",
  brandToken: "b_ch3tzpim",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/530b37f4c20d1cbf9938bc009d5afc73abd5e06e70a2d0accf5f12fb77e2db83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6b94cb88f4e2dd940e0e17b8a92573cad7ea25c7aa6410afc80e034714b899d.jpeg",
    "https://cdn.faire.com/fastly/f2d167d370a5e9f8d566acbe272b724abd8cd36f4dd84ad3ad5f2395242ee787.jpeg",
    "https://cdn.faire.com/fastly/b5c2db054f518fcfa030b92a02f010430b8626def6ce9c812560ef2332f6861d.jpeg",
    "https://cdn.faire.com/fastly/6b0abaac5f1c1895c749dd5d57c991f4c45cd596e97312fea96ea55ea670712b.jpeg",
    "https://cdn.faire.com/fastly/d62f42ccc14d431a0e573917d5b69d3938a38badf1b3f931a044f161c9af11d4.jpeg",
    "https://cdn.faire.com/fastly/121865d0495cd88894f6c8949fd03c3d600bc21a9ee3261bf2d3f36c140b860d.jpeg",
    "https://cdn.faire.com/fastly/e163e8b6ab5a3cc1b0c86e2c5a6be8769596399ca5f8c7ce5019631c2fad9249.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Our Cotton pant, meticulously crafted to perfection in Nepal. These pants are made from high-quality Cotton, ensuring both comfort and durability. The unique tie dye patch style adds a touch of uniqueness and artistic flair to each pair. With their unique style, these pants offer a blend of style and freedom of movement. Perfect for casual occasion, they are versatile and effortlessly chic. By offering our exceptional bohemian harem pants, you can provide your customers with a fashion-forward bohemian trend and ethically made choice. ",
  tags: [],
  msrpDollars: 41.57,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:25.510Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
